import React, { Component } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Row, Col, message } from 'antd';
import moment from 'moment';
import jobApi from '../../api/jobApi';

class JoinUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 5,
      page: 1,
      jobList: [],
    };
  }

  componentDidMount() {
    this.getJobList();
  }

  getJobList = () => {
    const data = {
      limit: this.state.limit,
      page: this.state.page,
    };

    jobApi.jobList(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          jobList: res.data.data.data,
        });
      } else {
        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs);
      }
    });
  };

  render() {
    const { jobList } = this.state;

    return (
      <div id="joinUs" className="joinUs">
        <div className="banner">
          <Image
            src={require('../../public/images/招聘banner-m.jpg').default}
            alt="招聘banner"
            layout="responsive"
            priority
          />
        </div>

        <div className="jobListBox">
          <div className="jobContent">
            <Row className="jobHeader marginTop20">
              <Col span={9} className="alignLeft">
                <div className="jobName">招聘职位</div>
              </Col>
              <Col span={7}>
                <div className="workPlace">工作地点</div>
              </Col>
              <Col span={8}>
                <div className="updateTime">更新时间</div>
              </Col>
            </Row>

            {jobList.length > 0 ? (
              jobList.map((item, index) => {
                return (
                  <Row className="marginTop20" key={index}>
                    <Col span={9} className="alignLeft">
                      <div className="jobName">
                        <Link href={`/joinus/${item.id}`}>
                          <a className="job">{item.title}</a>
                        </Link>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="workPlace">{item.location}</div>
                    </Col>
                    <Col span={8}>
                      <div className="updateTime">
                        {moment(item.created_at).format('YYYY-MM-DD')}
                      </div>
                    </Col>
                  </Row>
                );
              })
            ) : (
              <div style={{ marginTop: 30 }}>暂无岗位</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default JoinUs;
